// contexts/DiffCacheContext.tsx
import { createContext, useContext, useRef } from "react";

const DiffCacheContext = createContext(null);

export function DiffCacheProvider({ children }) {
  const cacheRef = useRef(new Map());
  return (
    <DiffCacheContext.Provider value={cacheRef}>
      {children}
    </DiffCacheContext.Provider>
  );
}

export function useDiffCache() {
  return useContext(DiffCacheContext);
}